var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useLayoutEffect } from 'react';
import './assets/css/bootstrap/bootstrap-grid.min.css';
import './assets/css/custom.css';
import './assets/css/media968.css';
import AppRoutes from './app/Routes';
import SportsBookService, { getLanguageFile, getSportSummery } from "./services/sportsbook.services";
import { AuthContext, loginSubject } from "./store/login.store";
import { postAwake, restoreLogin } from "./services/login.services";
import ModalService from "./components/modal/modal";
import Modal from "react-modal";
import { getSliders, isOffline, isOnline } from "./lib/misc.functions";
import { useTranslation } from "react-i18next";
import GamesService from "./services/games.service";
import { languageFile } from "./store/sportsbook.store";
export var inProgress = { state: false, };
var width = window.innerWidth;
export var isMobileView = width < 986 ? true : false;
var timer_sportsSummery;
export function getFromLanguageFile(nameId) {
    var _a, _b, _c;
    if (languageFile[(_a = localStorage.getItem('system_language')) !== null && _a !== void 0 ? _a : 'tr']) {
        if (languageFile[(_b = localStorage.getItem('system_language')) !== null && _b !== void 0 ? _b : 'tr'][nameId]) {
            return languageFile[(_c = localStorage.getItem('system_language')) !== null && _c !== void 0 ? _c : 'tr'][nameId];
        }
    }
    return false;
}
function App() {
    var _this = this;
    var _a = useState(false), isAuthenticated = _a[0], setIsAuthenticated = _a[1];
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    if (isMobileView) {
        document.getElementsByTagName('html')[0].classList.add('is-mobile');
        document.getElementsByTagName('html')[0].classList.remove('is-web');
    }
    useLayoutEffect(function () {
        getSliders();
    }, []);
    useEffect(function () {
        getLanguageFile(i18n.resolvedLanguage);
    }, [i18n.resolvedLanguage]);
    useEffect(function () {
        timer_sportsSummery = setInterval(function () {
            getSportSummery();
        }, 120000);
        return function () {
            clearInterval(timer_sportsSummery);
        };
    }, []);
    useEffect(function () {
        window.addEventListener("online", isOnline, false);
        window.addEventListener("offline", isOffline, false);
        return function () {
            window.removeEventListener('online', isOnline);
            window.removeEventListener('offline', isOffline);
        };
    }, []);
    useEffect(function () {
        window.addEventListener('resize', resizeWindow);
        return function () {
            window.removeEventListener('resize', resizeWindow);
        };
    }, []);
    var resizeWindow = function () {
        var width = window.innerWidth;
        var nowIsMobileView = width < 986 ? true : false;
        if (isMobileView !== nowIsMobileView) {
            if (!window.location.pathname.includes('/oyun')) {
                window.location.reload();
            }
        }
    };
    useEffect(function () {
        var loginSubject_subscription;
        if (!isAuthenticated) {
            // eğer token varsa otomatik auth icin wss i restore etmek icin var.
            restoreLogin();
            loginSubject_subscription = loginSubject.subscribe(function (member) {
                if (member.id !== undefined && member.status === 1) {
                    setIsAuthenticated(true);
                }
            });
        }
        return function () {
            loginSubject_subscription.unsubscribe();
        };
    }, []);
    useEffect(function () {
        var intervalId;
        var runLogic = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (intervalId)
                            clearInterval(intervalId);
                        if (!(document.visibilityState === "visible")) return [3 /*break*/, 2];
                        return [4 /*yield*/, postAwake()];
                    case 1:
                        _a.sent();
                        intervalId = setInterval(function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, postAwake()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        }); }); }, 300000);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        document.addEventListener("visibilitychange", runLogic);
        runLogic();
        return function () {
            document.removeEventListener("visibilitychange", runLogic);
            if (intervalId)
                clearInterval(intervalId);
        };
    }, []);
    // @ts-ignore
    Modal.setAppElement(document.getElementById('root'));
    return (_jsx(_Fragment, { children: _jsx(AuthContext.Provider, __assign({ value: { isAuthenticated: isAuthenticated, setIsAuthenticated: setIsAuthenticated } }, { children: _jsx(SportsBookService, { children: _jsx(GamesService, { children: _jsx(ModalService, { children: _jsx(AppRoutes, {}, void 0) }, void 0) }, void 0) }, void 0) }), void 0) }, void 0));
}
export default App;
